<template>
  <b-modal hide-footer v-model="showModal" no-close-on-backdrop size="lg" modal-class="system-update-modal"
    @hidden="onModalClose">
    <template #modal-header="{ close }">

      <div class="d-flex flex-column align-items-end">
        <div class="d-flex justify-content-between w-100 mb-3">

          <div>
            <h2><b>Atenção</b></h2>
          </div>

          <div>
            <b-button @click="close" variant="light">
              <i class="fas fa-times button" />
            </b-button>
          </div>
        </div>


        <div class="w-100">
          <b-img src="/img/image.png" fluid-grow class="header-image" />
        </div>

      </div>
    </template>

    <div class="modal-content-wrapper">
      <!-- Título Principal -->
      <div class="text-center mb-2">
        <h2 class="modal-title">
          <i class="fas fa-exclamation-triangle text-warning mr-2"></i>
          Atualização Importante do Sistema
        </h2>
      </div>

      <!-- Informação Principal -->
      <div class="info-section mb-2">
        <p class="text-body">
          Devido à <strong>Reforma Tributária</strong> e para atender às novas regras legais,
          o sistema atual de emissão de notas será desativado em:
        </p>
        <div class="date-highlight danger mb-3">
          <i class="far fa-calendar-times mr-2"></i>
          <span class="date-text">31/12/2025</span>
        </div>
      </div>

      <!-- Timeline Visual -->
      <div class="timeline-container mb-2">



        <div class="timeline-item">
          <div class="timeline-icon warning">
            <i class="fas fa-power-off"></i>
          </div>
          <div class="timeline-content">
            <span class="timeline-label">Desativação</span>
            <span class="timeline-date">31/12/2025</span>
          </div>
        </div>

        <div class="timeline-connector"></div>

        <div class="timeline-item">
          <div class="timeline-icon success">
            <i class="fas fa-rocket"></i>
          </div>
          <div class="timeline-content">
            <span class="timeline-label">Novo Sistema</span>
            <span class="timeline-date">02/01/2026</span>
          </div>
        </div>
      </div>

      <!-- Nova Data -->
      <div class="info-section mb-4">
        <p class="text-body">
          A partir de <span class="date-inline success">02/01/2026</span>, todas as notas fiscais
          serão emitidas <strong>exclusivamente pelo novo sistema</strong>.
        </p>
      </div>

      <!-- Instruções -->
      <div class="instructions-box mb-4">
        <div class="instruction-header">
          <i class="fas fa-tasks mr-2"></i>
          <h4>Sobre a Troca de Sistema</h4>
        </div>
        <p class="instruction-text">
          Cadastro de <strong>produtos, clientes, fornecedores e crediários</strong>
          serão migrados automaticamente para o novo sistema.
        </p>
        <br />
        <p class="instruction-text">
          Para continuar emitindo notas, envie seu <strong>certificado digital</strong>
          para o número de suporte para realizar a migração para o novo sistema.
        </p>
      </div>

      <!-- Alerta Crítico -->
      <div class="critical-alert mb-4">
        <div class="alert-icon">
          <i class="fas fa-exclamation-circle"></i>
        </div>
        <div class="alert-content">
          <strong>Atenção:</strong> Sem o envio do certificado digital,
          não será possível emitir notas fiscais a partir de 02/01/2026.
        </div>
      </div>

      <!-- Call to Action -->
      <div class="cta-section text-center">
        <b-button variant="primary" size="lg" class="cta-button" @click="handleMigration">
          <i class="fas fa-certificate mr-2"></i>
          Enviar Certificado Digital
        </b-button>

      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
      checkInterval: null,
      pageJustLoaded: true
    };
  },

  computed: {
    isModuleActive() {
      return this.$store.state.auth.user.company.module_nfe_active == 1;
    }
  },

  mounted() {
    this.checkShouldShowModal();
    // Verificar a cada 5 segundos se deve mostrar o modal
    this.checkInterval = setInterval(() => {
      this.pageJustLoaded = false;
      this.checkShouldShowModal();
    }, 5 * 1000); // 5 segundos
  },

  beforeDestroy() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  },

  methods: {
    checkShouldShowModal() {
      if (!this.isModuleActive) {
        return;
      }

      const lastClosedTime = localStorage.getItem('systemUpdateModalLastClosed');
      const now = Date.now();
      const oneHour = 60 * 60 * 1000; // 1 hora em milissegundos


      // Se a página acabou de ser carregada (F5), sempre mostra o modal
      if (this.pageJustLoaded) {
        this.showModal = true;
        return;
      }

      if (!lastClosedTime) {
        // Se nunca foi fechado, mostra o modal
        this.showModal = true;
      } else {
        const timeSinceLastClose = now - parseInt(lastClosedTime);
        if (timeSinceLastClose >= oneHour) {
          // Se passou 1 hora ou mais, mostra o modal
          this.showModal = true;
        }
      }
    },

    onModalClose() {
      // Salvar o timestamp de quando o modal foi fechado
      localStorage.setItem('systemUpdateModalLastClosed', Date.now().toString());
      this.showModal = false;
      this.pageJustLoaded = false;
    },

    handleMigration() {
      let href = "https://api.whatsapp.com/send?phone=+5533984072771&text=Ol%C3%A1%20,%20Gostariamos%20de%20solicitar%20por%20suporte%20técnico!"
      window.open(href, "_blank");
    }
  }
};
</script>

<style scoped>
/* Modal Customization */
.modal-content-wrapper {
  padding: 24px 32px;
}

/* Header */
.header-image {
  max-height: 150px;
  object-fit: contain;
}

/* Título */
.modal-title {
  font-size: 26px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
  line-height: 1.3;
}

/* Seções de Informação */
.info-section {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}

.text-body {
  font-size: 16px;
  line-height: 1.6;
  color: #495057;
  margin-bottom: 16px;
}

/* Destaque de Datas */
.date-highlight {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 24px;
  font-weight: 700;
}

.date-highlight.danger {
  background: #ffe6e6;
  color: #dc3545;
  border: 2px solid #dc3545;
}

.date-highlight i {
  font-size: 28px;
}

.date-text {
  font-size: 28px;
}

.date-inline {
  font-weight: 700;
  font-size: 18px;
  padding: 2px 8px;
  border-radius: 4px;
}

.date-inline.success {
  background: #d4edda;
  color: #155724;
}

/* Timeline */
.timeline-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 16px;
  background: #f8f9fa;
  border-radius: 8px;
}

.timeline-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.timeline-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 12px;
  border: 3px solid;
}

.timeline-icon.current {
  background: #e3f2fd;
  color: #1976d2;
  border-color: #1976d2;
}

.timeline-icon.warning {
  background: #fff3cd;
  color: #dc3545;
  border-color: #dc3545;
}

.timeline-icon.success {
  background: #d4edda;
  color: #28a745;
  border-color: #28a745;
}

.timeline-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.timeline-label {
  font-size: 14px;
  font-weight: 600;
  color: #6c757d;
  margin-bottom: 4px;
}

.timeline-date {
  font-size: 16px;
  font-weight: 700;
  color: #2c3e50;
}

.timeline-connector {
  flex: 0 0 60px;
  height: 3px;
  background: linear-gradient(to right, #dee2e6 0%, #dee2e6 100%);
  margin: 0 8px;
  margin-bottom: 40px;
}

/* Caixa de Instruções */
.instructions-box {
  background: #e7f3ff;
  border-left: 4px solid #1976d2;
  padding: 20px 24px;
  border-radius: 8px;
}

.instruction-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.instruction-header h4 {
  font-size: 18px;
  font-weight: 700;
  color: #1976d2;
  margin: 0;
}

.instruction-text {
  font-size: 16px;
  line-height: 1.6;
  color: #495057;
  margin: 0;
}

/* Alerta Crítico */
.critical-alert {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: #ffe6e6;
  border: 2px solid #dc3545;
  border-radius: 8px;
  padding: 20px 24px;
}

.alert-icon {
  flex-shrink: 0;
}

.alert-icon i {
  font-size: 32px;
  color: #dc3545;
}

.alert-content {
  font-size: 16px;
  font-weight: 500;
  color: #721c24;
  line-height: 1.6;
}

/* Call to Action */
.cta-section {
  padding-top: 8px;
}

.cta-button {
  font-size: 18px;
  font-weight: 700;
  padding: 14px 32px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border: none;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 123, 255, 0.4);
}

.cta-button:active {
  transform: translateY(0);
}

.help-text {
  font-size: 14px;
  color: #6c757d;
  margin: 0;
}

/* Responsividade */
@media (max-width: 768px) {
  .modal-content-wrapper {
    padding: 16px 20px;
  }

  .modal-title {
    font-size: 22px;
  }

  .timeline-container {
    flex-direction: column;
    gap: 16px;
  }

  .timeline-connector {
    width: 3px;
    height: 40px;
    margin: 0;
    background: linear-gradient(to bottom, #dee2e6 0%, #dee2e6 100%);
  }

  .date-text {
    font-size: 22px;
  }

  .cta-button {
    width: 100%;
    font-size: 16px;
  }
}
</style>